import { mainnet, sepolia } from 'wagmi/chains';
import { createPublicClient, http } from 'viem';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {metaMaskWallet,rainbowWallet,walletConnectWallet,} from '@rainbow-me/rainbowkit/wallets';

import { createConfig } from 'wagmi';

// Define the Amoy test network
const amoyTestnet = {
  id: 80002,
  name: 'Amoy Testnet',
  network: 'amoy',
  nativeCurrency: {
    name: 'Polygon',
    symbol: 'POL',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ['https://rpc-amoy.polygon.technology/'] }, //  RPC URL
  },
  blockExplorers: {
    default: { name: 'AmoyScan', url: 'https://amoy.polygonscan.com' }, //  block explorer URL
  },
};

// Define the local Hardhat network
const hardhatLocal = {
  id: 31337, // Hardhat's default chain ID
  name: 'Hardhat Local',
  network: 'hardhat',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ['http://127.0.0.1:8545'] }, // Local Hardhat RPC URL
  },
  blockExplorers: {
    default: { name: 'Hardhat Local Explorer', url: 'http://localhost:8545' }, // No default block explorer
  },
};

const chains = [mainnet, sepolia, amoyTestnet, hardhatLocal]; // Include Hardhat network

const publicClient = createPublicClient({
  chain: hardhatLocal, // Use Hardhat for local development
  transport: http(),
});

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, rainbowWallet, walletConnectWallet],
    },
  ],
  {
    appName: 'My RainbowKit App',
    projectId: '40933fab63620b6c2a9a24f85ae3fd8e',
  }
);

const wagmiConfig = createConfig({
  //chains: [mainnet, sepolia, amoyTestnet, hardhatLocal], // Include Hardhat network here
  chains: [amoyTestnet, hardhatLocal],
  connectors,
  transports: {
   // [mainnet.id]: http('https://mainnet.example.com'),
   // [sepolia.id]: http('https://sepolia.example.com'),
    [amoyTestnet.id]: http('https://rpc-amoy.polygon.technology/'), // Amoy RPC
    [hardhatLocal.id]: http('http://127.0.0.1:8545'), // Local Hardhat RPC
  },
  
});

export { chains, wagmiConfig };
